import * as React from 'react';

var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var SvgArrowLeftMid = function SvgArrowLeftMid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5303 5.21967C10.8232 5.51256 10.8232 5.98744 10.5303 6.28033L5.56066 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H5.56066L10.5303 17.7197C10.8232 18.0126 10.8232 18.4874 10.5303 18.7803C10.2374 19.0732 9.76256 19.0732 9.46967 18.7803L3.21967 12.5303C2.92678 12.2374 2.92678 11.7626 3.21967 11.4697L9.46967 5.21967C9.76256 4.92678 10.2374 4.92678 10.5303 5.21967Z"
  })));
};

export { SvgArrowLeftMid as ReactComponent };
//# sourceMappingURL=arrow-left-mid.svg.js.map
